import {
  ROUTE_LEVEL_RANGES,
  ROUTE_UNLOCK_LEVELS,
  TYPE_UNLOCK_LEVEL,
  ZONE_HUNT_MIN_LEVEL,
  ENDGAME_ZONES,
  endgameZoneAccess,
  zoneConfigForBand,
  gmt3HourKey,
  msUntilNextGmt3Hour,
  featuredSpecialSpecies,
  rollZoneSpecial,
  ZONE_SPECIAL_CHANCE,
  bandForLevel,
  combatIntervalMs,
  combatXpForLevel,
  combatRiskMultiplier,
  encounterLevel,
  HUNT_DIFFICULTIES,
  configureBalanceData,
  isTypeUnlockedForRoute,
  isTypeUnlockedForTrainer,
  isZoneHuntBand,
  isZoneHuntLevel,
  huntAtlasMaxSpecies,
  lineageForSpecies,
  killXpBonusForDefeats,
  masteryDamageMultiplier,
  normalizeTrainerTalents,
  pokemonMasteryXpToNext,
  rollRouteEncounter,
  routeEncounters,
  fishingEncounters,
  rollFishingEncounter,
  routeLevelAt,
  softenedRarityStatMultiplier,
  speciesEntry,
  speciesEncounterLocations,
  speciesEvolutionDepth,
  speciesMinRouteLevel,
  typeUnlockLevel,
  trainerXpToNextLevel,
  trainerXpForKill,
  offlinePokemonXpPct,
  OFFLINE_POKEMON_PCT_PER_RANK,
  OFFLINE_POKEMON_PCT_MAX,
  authoritativeDefeats,
  trainerPerks,
  trainerTalentPoints,
  trainerTalentPointsFromDefeats,
  trainerTalentPointsSpent,
  TRAINER_TALENT_KEYS,
  pokemonXpToNext,
} from './balance-core.mjs';

export {
  ROUTE_LEVEL_RANGES,
  ROUTE_UNLOCK_LEVELS,
  TYPE_UNLOCK_LEVEL,
  ZONE_HUNT_MIN_LEVEL,
  ENDGAME_ZONES,
  endgameZoneAccess,
  zoneConfigForBand,
  gmt3HourKey,
  msUntilNextGmt3Hour,
  featuredSpecialSpecies,
  rollZoneSpecial,
  ZONE_SPECIAL_CHANCE,
  isTypeUnlockedForRoute,
  isTypeUnlockedForTrainer,
  isZoneHuntBand,
  isZoneHuntLevel,
  huntAtlasMaxSpecies,
  routeLevelAt,
  speciesMinRouteLevel,
  typeUnlockLevel,
  combatIntervalMs,
  combatXpForLevel,
  combatRiskMultiplier,
  encounterLevel,
  HUNT_DIFFICULTIES,
  masteryDamageMultiplier,
  pokemonMasteryXpToNext,
  authoritativeDefeats,
  trainerPerks,
  trainerTalentPoints,
  trainerTalentPointsFromDefeats,
  trainerTalentPointsSpent,
  normalizeTrainerTalents,
  killXpBonusForDefeats,
  TRAINER_TALENT_KEYS,
};

export const routeSlugs={
  'elétrico':'electric','fogo':'fire','água':'water','planta':'grass','inseto':'bug','voador':'flying','normal':'normal','psíquico':'psychic','pedra':'rock','terra':'ground','fantasma':'ghost','dragão':'dragon','lutador':'fighting','veneno':'poison','sombrio':'dark','aço':'steel','gelo':'ice','fada':'fairy'
};

export const routeChains={
  'elétrico':[['pichu','pikachu','raichu'],['mareep','flaaffy','ampharos'],['elekid','electabuzz','electivire'],['magnemite','magneton','magnezone'],['voltorb','electrode']],
  'fogo':[['charmander','charmeleon','charizard'],['vulpix','ninetales'],['growlithe','arcanine'],['slugma','magcargo'],['ponyta','rapidash'],['houndour','houndoom']],
  'água':[['squirtle','wartortle','blastoise'],['poliwag','poliwhirl','poliwrath'],['horsea','seadra','kingdra'],['magikarp','gyarados'],['tentacool','tentacruel'],['lotad','lombre','ludicolo']],
  'planta':[['bulbasaur','ivysaur','venusaur'],['oddish','gloom','vileplume'],['bellsprout','weepinbell','victreebel'],['chikorita','bayleef','meganium'],['treecko','grovyle','sceptile'],['hoppip','skiploom','jumpluff']],
  'inseto':[['caterpie','metapod','butterfree'],['weedle','kakuna','beedrill'],['paras','parasect'],['venonat','venomoth'],['spinarak','ariados'],['scyther','scizor']],
  'voador':[['pidgey','pidgeotto','pidgeot'],['spearow','fearow'],['zubat','golbat','crobat'],['doduo','dodrio'],['hoothoot','noctowl'],['natu','xatu']],
  'normal':[['rattata','raticate'],['meowth','persian'],['sentret','furret'],['zigzagoon','linoone'],['cleffa','clefairy','clefable'],['igglybuff','jigglypuff','wigglytuff']],
  'psíquico':[['abra','kadabra','alakazam'],['drowzee','hypno'],['natu','xatu'],['ralts','kirlia','gardevoir'],['meditite','medicham'],['beldum','metang','metagross']],
  'pedra':[['geodude','graveler','golem'],['onix','steelix'],['rhyhorn','rhydon'],['larvitar','pupitar','tyranitar'],['aron','lairon','aggron'],['kabuto','kabutops']],
  'terra':[['sandshrew','sandslash'],['diglett','dugtrio'],['cubone','marowak'],['phanpy','donphan'],['trapinch','vibrava','flygon'],['swinub','piloswine','mamoswine']],
  'fantasma':[['gastly','haunter','gengar'],['misdreavus','mismagius'],['shuppet','banette'],['duskull','dusclops','dusknoir'],['sableye']],
  'dragão':[['dratini','dragonair','dragonite'],['bagon','shelgon','salamence'],['gible','gabite','garchomp']],
  'lutador':[['machop','machoke','machamp'],['mankey','primeape'],['makuhita','hariyama'],['meditite','medicham'],['riolu','lucario'],['tyrogue','hitmonchan']],
  'veneno':[['ekans','arbok'],['nidoran-f','nidorina','nidoqueen'],['koffing','weezing'],['grimer','muk'],['gulpin','swalot'],['venonat','venomoth']],
  'sombrio':[['sneasel','weavile'],['murkrow','honchkrow'],['poochyena','mightyena'],['houndour','houndoom'],['absol'],['sableye']],
  'aço':[['magnemite','magneton','magnezone'],['aron','lairon','aggron'],['beldum','metang','metagross'],['pineco','forretress'],['skarmory'],['mawile']],
  'gelo':[['swinub','piloswine','mamoswine'],['spheal','sealeo','walrein'],['smoochum','jynx'],['snorunt','glalie'],['seel','dewgong'],['sneasel','weavile']],
  'fada':[['cleffa','clefairy','clefable'],['igglybuff','jigglypuff','wigglytuff'],['snubbull','granbull'],['togepi','togetic','togekiss'],['ralts','kirlia','gardevoir'],['mawile']]
};

const primaryTypeOverrides={
  cleffa:'fada',clefairy:'fada',clefable:'fada',natu:'psíquico',xatu:'psíquico',ralts:'psíquico',kirlia:'psíquico',gardevoir:'psíquico',
  meditite:'lutador',medicham:'lutador',onix:'pedra',steelix:'aço',rhyhorn:'terra',rhydon:'terra',aron:'aço',lairon:'aço',aggron:'aço',
  nidoran_f:'veneno',nidorina:'veneno',nidoqueen:'veneno',magnemite:'elétrico',magneton:'elétrico',magnezone:'elétrico',
  beldum:'aço',metang:'aço',metagross:'aço',skarmory:'aço',mawile:'aço',sneasel:'sombrio',weavile:'sombrio',
  spheal:'gelo',sealeo:'gelo',walrein:'gelo',seel:'água',dewgong:'água'
};

export const secondaryTypes={
  charizard:'voador',magcargo:'pedra',houndour:'sombrio',houndoom:'sombrio',poliwrath:'lutador',kingdra:'dragão',lotad:'planta',lombre:'planta',ludicolo:'planta',
  bulbasaur:'veneno',ivysaur:'veneno',venusaur:'veneno',oddish:'veneno',gloom:'veneno',vileplume:'veneno',bellsprout:'veneno',weepinbell:'veneno',victreebel:'veneno',
  butterfree:'voador',beedrill:'veneno',paras:'planta',parasect:'planta',venonat:'veneno',venomoth:'voador',spinarak:'veneno',ariados:'veneno',scyther:'voador',scizor:'aço',
  zubat:'voador',golbat:'voador',crobat:'voador',natu:'voador',xatu:'voador',igglybuff:'fada',jigglypuff:'fada',wigglytuff:'fada',
  geodude:'terra',graveler:'terra',golem:'terra',onix:'terra',steelix:'terra',rhyhorn:'pedra',rhydon:'pedra',larvitar:'terra',pupitar:'terra',tyranitar:'sombrio',aron:'pedra',lairon:'pedra',aggron:'pedra',kabuto:'água',kabutops:'água',
  gastly:'veneno',haunter:'veneno',gengar:'veneno',sableye:'sombrio',dragonite:'voador',salamence:'voador',flygon:'dragão',garchomp:'terra',
  nidoqueen:'terra',skarmory:'voador',magnemite:'aço',magneton:'aço',magnezone:'aço',forretress:'inseto',
  beldum:'psíquico',metang:'psíquico',metagross:'psíquico',meditite:'psíquico',medicham:'psíquico',riolu:'aço',lucario:'aço',
  sneasel:'gelo',weavile:'gelo',spheal:'água',sealeo:'água',walrein:'água',dewgong:'gelo',ralts:'fada',kirlia:'fada',gardevoir:'fada',mawile:'fada'
};

export const typeChart={
  normal:{pedra:.5,fantasma:0,aço:.5},fogo:{fogo:.5,água:.5,planta:2,gelo:2,inseto:2,pedra:.5,dragão:.5,aço:2},água:{fogo:2,água:.5,planta:.5,terra:2,pedra:2,dragão:.5},
  elétrico:{água:2,elétrico:.5,planta:.5,terra:0,voador:2,dragão:.5},planta:{fogo:.5,água:2,planta:.5,veneno:.5,terra:2,voador:.5,inseto:.5,pedra:2,dragão:.5,aço:.5},
  gelo:{fogo:.5,água:.5,planta:2,gelo:.5,terra:2,voador:2,dragão:2,aço:.5},lutador:{normal:2,gelo:2,veneno:.5,voador:.5,psíquico:.5,inseto:.5,pedra:2,fantasma:0,sombrio:2,aço:2,fada:.5},
  veneno:{planta:2,veneno:.5,terra:.5,pedra:.5,fantasma:.5,aço:0,fada:2},terra:{fogo:2,elétrico:2,planta:.5,veneno:2,voador:0,inseto:.5,pedra:2,aço:2},
  voador:{elétrico:.5,planta:2,lutador:2,inseto:2,pedra:.5,aço:.5},psíquico:{lutador:2,veneno:2,psíquico:.5,sombrio:0,aço:.5},inseto:{fogo:.5,planta:2,lutador:.5,veneno:.5,voador:.5,psíquico:2,fantasma:.5,sombrio:2,aço:.5,fada:.5},
  pedra:{fogo:2,gelo:2,lutador:.5,terra:.5,voador:2,inseto:2,aço:.5},fantasma:{normal:0,psíquico:2,fantasma:2,sombrio:.5},dragão:{dragão:2,aço:.5,fada:0},
  sombrio:{lutador:.5,psíquico:2,fantasma:2,sombrio:.5,fada:.5},aço:{fogo:.5,água:.5,elétrico:.5,gelo:2,pedra:2,aço:.5,fada:2},fada:{fogo:.5,lutador:2,veneno:.5,dragão:2,sombrio:2,aço:.5}
};

const stageStats=[{hp:45,atk:48,def:45,spa:48,spd:45,spe:45},{hp:65,atk:68,def:65,spa:68,spd:65,spe:60},{hp:88,atk:92,def:85,spa:92,spd:85,spe:80}];
export function configureBattleData(pokedex){return configureBalanceData(pokedex)}
export function encountersForRoute(routeType,band){return routeEncounters(routeType,band)}
export function encountersForFishing(band){return fishingEncounters(band)}
export function rollFish(band,random=Math.random){return rollFishingEncounter(band,random)}
export function encounterLocationsForSpecies(name){return speciesEncounterLocations(name)}
export function evolutionDepthForSpecies(name){return speciesEvolutionDepth(name)}
export function formForLevel(chain,level){if(chain.length===1)return chain[0];if(chain.length===2)return chain[level>=60?1:0];return chain[level>=70?2:level>=40?1:0]}
export function chainForSpecies(name){return lineageForSpecies(name)||Object.values(routeChains).flat().find(chain=>chain.includes(name))}
export function speciesForLevel(routeType,level,random=Math.random){
  const balanced=rollRouteEncounter(routeType,bandForLevel(level),random);
  if(balanced)return balanced;
  if(!isTypeUnlockedForRoute(routeType,level))return'rattata';
  const chains=routeChains[routeType]||[];
  const chain=chains[Math.floor(random()*chains.length)];
  return chain?formForLevel(chain,level):'rattata';
}
function canonicalPrimaryType(name,routeType){
  if(!name)return routeType||'normal';
  const key=String(name).replace('-','_');
  if(primaryTypeOverrides[key])return primaryTypeOverrides[key];
  return Object.entries(routeChains).find(([,chains])=>chains.some(chain=>chain.includes(name)))?.[0]||routeType||'normal';
}
export function speciesTypes(name,routeType){
  if(!name)return routeType?[routeType]:['normal'];
  const entry=speciesEntry(name);
  if(entry?.types?.length)return[...entry.types];
  const key=String(name).replace('-','_'),types=[canonicalPrimaryType(name,routeType),secondaryTypes[key]];
  return[...new Set(types.filter(Boolean))];
}
function ivValue(ivs,key){const aliases={hp:'HP',atk:'ATK',def:'DEF',spa:'ESP',spd:'RES',spe:'VEL'};return ivs[key]??ivs[aliases[key]]??15}
const MIN_STAT_SCALING_LEVEL=10;
const HP_RESOLUTION_MULTIPLIER=2;
/** Peso do IV no cálculo de stats — k=3 aproxima o feel do growth do Poke Idle World. */
export const IV_STAT_WEIGHT=3;
/**
 * IV de referência do balanceamento. O peso k gira o IV em torno deste ponto em
 * vez de somar a partir do zero: um exemplar médio (IV 15) mantém os stats sobre
 * os quais a curva foi calibrada, enquanto IV 31 sobe e IV 0 desce muito mais do
 * que subiriam com k=1. Sem o pivô, k=3 empurrava a média de todo selvagem para
 * cima — inflava a vida do lixo comum junto com a do exemplar perfeito.
 */
export const IV_STAT_PIVOT=15;
const ivTerm=(ivs,key)=>IV_STAT_WEIGHT*ivValue(ivs,key)-(IV_STAT_WEIGHT-1)*IV_STAT_PIVOT;
export function statsFor(name,routeType,level,ivs={hp:15,atk:15,def:15,spa:15,spd:15,spe:15},rarityMultiplier=1){
  const entry=speciesEntry(name),chain=chainForSpecies(name)||[name],stage=Math.max(0,chain.indexOf(name)),base=entry?.baseStats||stageStats[Math.min(stage,2)];
  const actualLevel=Math.max(1,Number(level)||1),scalingLevel=Math.max(MIN_STAT_SCALING_LEVEL,actualLevel),statMult=softenedRarityStatMultiplier(rarityMultiplier);
  const scaled=value=>Math.max(1,Math.floor(value*statMult)),stat=k=>scaled(Math.floor((Math.max(1,2*base[k]+ivTerm(ivs,k))*scalingLevel)/100)+5);
  // O piso de escala preserva as diferenças entre espécies no Nv.1. HP usa
  // unidades maiores para que um ponto de dano não represente 8-10% da vida.
  const hp=scaled((Math.floor((Math.max(1,2*base.hp+ivTerm(ivs,'hp'))*scalingLevel)/100)+actualLevel+10)*HP_RESOLUTION_MULTIPLIER);
  return{hp,atk:stat('atk'),def:stat('def'),spa:stat('spa'),spd:stat('spd'),spe:stat('spe')};
}
/** Power: rarity is already represented once in statsFor; do not multiply it again. */
export function powerRarityMultiplier(){return 1}
export function pokemonPower(stats){const total=['hp','atk','def','spa','spd','spe'].reduce((sum,key)=>sum+Math.max(0,Number(stats?.[key])||0),0);return Math.round(total)}
export function effectiveness(attackType,defenderTypes){return defenderTypes.reduce((mult,type)=>mult*(typeChart[attackType]?.[type]??1),1)}
export function emphasizedEffectiveness(rawMultiplier, emphasis = 0.5){const mult=Math.max(0,Number(rawMultiplier)||0);if(mult===0||mult===1)return mult;if(mult>1)return 1+(mult-1)*(1+emphasis);return mult/(1+emphasis)}
export function damageFor(attacker,defender,moveType,power=60,category=null,random=Math.random){
  const specialTypes=['fogo','água','elétrico','planta','gelo','psíquico','dragão','sombrio','fada'];
  const isSpecial=category==='special'?true:category==='physical'?false:specialTypes.includes(moveType);
  const attack=isSpecial?attacker.stats.spa:attacker.stats.atk;
  const defense=Math.max(1,isSpecial?defender.stats.spd:defender.stats.def);
  const stab=attacker.types.includes(moveType)?1.5:1;
  const mult=effectiveness(moveType,defender.types);
  const variance=.9+Math.max(0,Math.min(1,Number(random())||0))*.1;
  // O piso vale para qualquer combatente e evita que o fator de nível torne
  // os primeiros confrontos artificialmente lentos. Não depende da rota.
  const combatLevel=Math.max(MIN_STAT_SCALING_LEVEL,Math.max(1,Number(attacker.level)||1));
  const base=(((2*combatLevel/5+2)*power*attack/defense)/50)+2;
  const damage=Math.max(1,Math.floor(base*stab*mult*variance));
  return{damage:mult===0?0:damage,mult,category:isSpecial?'special':'physical'};
}
export const xpToNext=pokemonXpToNext;
export const MAX_TRAINER_LEVEL=300;
export const trainerXpToNext=trainerXpToNextLevel;
export{trainerXpForKill,offlinePokemonXpPct,OFFLINE_POKEMON_PCT_PER_RANK,OFFLINE_POKEMON_PCT_MAX};
/** EXP base ao derrotar um wild (o Pokémon usa esta; o treinador usa trainerXpForKill). */
export function combatXpReward(wildLevel,bonus=0,speciesName=null,playerLevel=wildLevel){return combatXpForLevel(wildLevel,speciesEntry(speciesName),bonus,playerLevel)}
